import script from "./import.vue?vue&type=script&setup=true&lang=js"
export * from "./import.vue?vue&type=script&setup=true&lang=js"

import "./import.vue?vue&type=style&index=0&id=e5ec4ffc&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e5ec4ffc"]])

export default __exports__